import { jcropReactStyle } from '@bingads-webui/image-cropper';

export const getStyle = () => {
  const commonHandlePseudoBefore = {
    content: '" "',
    position: 'absolute',
    zIndex: '-1',
    width: 16,
    height: 16,
    opacity: '1',
  };

  return {
    ...jcropReactStyle,

    // customized style
    container: {
      display: 'table',
      margin: '0 auto',

      '& .jcrop-handle': {
        backgroundColor: 'rgba(255,255,255,0)',
        opacity: '0.5!important',
        width: 20,
        height: 20,
        border: 'none',
        margin: 0,
      },
      '& .jcrop-handle.ord-ne': {
        borderRight: '6px #000000 solid',
        borderTop: '6px #000000 solid',
        margin: 0,
      },
      '& .jcrop-handle.ord-ne:before': {
        ...commonHandlePseudoBefore,
        top: '0',
        right: '0',
        borderRight: '2px solid white',
        borderTop: '2px solid white',
        marginTop: -4,
        marginRight: -4,
      },
      '& .jcrop-handle.ord-se': {
        borderRight: '6px #000000 solid',
        borderBottom: '6px #000000 solid',
        margin: 0,
      },
      '& .jcrop-handle.ord-se:before': {
        ...commonHandlePseudoBefore,
        bottom: '0',
        right: '0',
        borderRight: '2px solid white',
        borderBottom: '2px solid white',
        marginBottom: -4,
        marginRight: -4,
      },
      '& .jcrop-handle.ord-nw': {
        borderLeft: '6px #000000 solid',
        borderTop: '6px #000000 solid',
        margin: 0,
      },
      '& .jcrop-handle.ord-nw:before': {
        ...commonHandlePseudoBefore,
        top: '0',
        left: '0',
        borderLeft: '2px solid white',
        borderTop: '2px solid white',
        marginTop: -4,
        marginLeft: -4,
      },
      '& .jcrop-handle.ord-sw': {
        borderLeft: '6px #000000 solid',
        borderBottom: '6px #000000 solid',
        margin: 0,
      },
      '& .jcrop-handle.ord-sw:before': {
        ...commonHandlePseudoBefore,
        bottom: '0',
        left: '0',
        borderLeft: '2px solid white',
        borderBottom: '2px solid white',
        marginBottom: -4,
        marginLeft: -4,
      },
      '& .jcrop-holder': {
        display: 'inline-block',
      },
      '& .jcrop-holder .jcrop-tracker': {
        height: '100%',
        width: '100%',
      },
      '& .jcrop-holder .jcrop-keymgr': {
        visibility: 'hidden',
      },
    },
  };
};
